import { render, staticRenderFns } from "./addSettled.vue?vue&type=template&id=14137ad8&scoped=true&"
import script from "./addSettled.vue?vue&type=script&lang=js&"
export * from "./addSettled.vue?vue&type=script&lang=js&"
import style0 from "./addSettled.vue?vue&type=style&index=0&id=14137ad8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14137ad8",
  null
  
)

export default component.exports